export default "__VITE_ASSET__374abe2b__"